import api from "./api";

export const adminUserService = {
  getAll: async () => (await api.get("/admin/users")).data,
  getById: async (id: string) => (await api.get(`/admin/users/${id}`)).data,
  create: async (data: any) => (await api.post("/admin/users", data)).data,
  update: async (id: string, data: any) => (await api.put(`/admin/users/${id}`, data)).data,
  remove: async (id: string) => (await api.delete(`/admin/users/${id}`)).data,
};

export default adminUserService